/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
import type { Logger } from '../resiliencedb/types';

import PullBatchableQueue from './PullBatchableQueue';
import {
	type BatchableQueue,
	type BatchFlushCallback,
	type Callback,
	ResilienceMechanism,
	type RetryQueueOptions,
} from './types';

export type { BatchableQueue, BatchFlushCallback, Callback, RetryQueueOptions };

// Enum isnt just a type, its also an object that needs to be
// exported as an object.
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { ResilienceMechanism };

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export default <T extends object>(
	retryQueuePrefix: string,
	product: string,
	options?: RetryQueueOptions,
	logger?: Logger,
): BatchableQueue<T> => {
	return new PullBatchableQueue(retryQueuePrefix, product, options || {}, logger);
};
